import { render, staticRenderFns } from "./UserLabel.vue?vue&type=template&id=638dbff4"
import script from "./UserLabel.vue?vue&type=script&lang=js"
export * from "./UserLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports